<template>
  <li>
    <div  :id="data.id" :data-obj="JSON.stringify(data)">
      <span @click="toggle" :class="{bold:isFolder}" >
        {{data.name}}
      </span>
      <slot/>
    </div>
    <ul v-show="open" v-if='isFolder'>
      <hz-tree v-for='item in data.children' :data="item">
        <slot/>
      </hz-tree>
    </ul>
  </li>
      <!--<ul>-->
        <!--<li>-->
          <!--<div :class="{bold: isFolder}">-->
            <!--<span @click="toggle" class="item">{{data.name}}</span>-->
            <!--<slot v-bind:row="data"/>-->
          <!--</div>-->
          <!--<ul v-show="open" v-if="isFolder">-->
            <!--<hz-tree class="item" v-for="(item,index) in data.children" :key="index" :data="item">-->
              <!--<slot v-bind:row="item" v-bind:index="index"/>-->
            <!--</hz-tree>-->
          <!--</ul>-->
        <!--</li>-->
      <!--</ul>-->
</template>
<script>
  export default{
    props:{
      data:Object,
    },
    data(){
      return{
        open:false,
        item:{}
      }
    },
    computed: {
      isFolder: function () {// 是否有文件，有的话返回子文件和子文件个数
        return this.data.children && this.data.children.length
      },

    },
    methods: {
      toggle: function () {// 如果有孩子时，选择展示或者隐藏孩子
        if (this.isFolder) {
          this.open = !this.open
        }
      },

    }

  }
</script>
<style>
  ul {
    padding-left: 1em;
    line-height: 1.5em;
    list-style-type: dot;
  }
  body {
    font-family: Menlo, Consolas, monospace;
    color: #444;
  }
  .item {
    cursor: pointer;
  }
  .bold {
    font-weight: bold;
  }
</style>




// WEBPACK FOOTER //
// src/components/tree.vue